import useLocalization from '../../hooks/useLocalization';
import MaintenanceNotice from '../shared/MaintenanceNotice';

const MaintenancePage = () => {
  const { t } = useLocalization();

  return (
    <MaintenanceNotice
      title={t('maintenanceMode')}
      messages={[t('maintenanceMessage')]}
    />
  );
};

export default MaintenancePage;
